import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase/firebase";
import Hotjar from "@hotjar/browser";

const Tracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(location.pathname);
    }
    logEvent(analytics, "page_view", { page: location.pathname });
    console.log(`Tracking page: ${location.pathname}`);
  }, [location]);

  return null;
};

export default Tracking;
